import React from 'react';
import {Text, View} from 'react-native';
import {
  accentColor,
  groupCountPillBg,
  groupCountPillText
} from '../../../style/adminTools';

const Pill = ({text, testID, tone, style}) => (
  <View
    testID={testID}
    style={{
      backgroundColor: tone === 'ok' ? accentColor : groupCountPillBg,
      borderRadius: 12,
      paddingHorizontal: 10,
      paddingVertical: 3,
      ...style
    }}
  >
    <Text style={groupCountPillText}>{text}</Text>
  </View>
);

export default Pill;
